/* TESTES POSTMAN
 * https://api.innovac.com.br/api/auth/login?email=roberto.magazoni@gmail.com&password=Innovac2022
 */
import axios from 'axios'

const api = axios.create({    
    baseURL        : 'https://api.innovac.com.br/api',
    withCredentials: true,
    timeout        : 1000,
    //headers        : {'X-Requested-With': 'XMLHttpRequest'},
    //responseType   : 'json',
})

export const apiCep = axios.create({    
    baseURL : 'https://viacep.com.br/ws/',
})

export default api;